module.exports = __webpack_public_path__ + "static/media/step-indicator-2.66d90316.svg";